import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import { Route } from "react-router-dom";
import withUser from "../hoc/withUser";
import InvoiceDetails from "../components/InvoiceDetails";
class InvoiceDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      allCustomers: [],
      appBarName: null,
      customersList: [],
      tempProducts: [],
      organisationId: ""
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    let deals = whichProps.allDeals ? whichProps.allDeals : null;
    let customerId = this.props.match.params.customerId;
    let allCustomers = whichProps.allCustomers
      ? whichProps.allCustomers.find(
          customer => customer.id === this.props.match.params.customerId
        )
      : null;
    let allInvoices = whichProps.allInvoices ? whichProps.allInvoices : null;
    const invoicedDealsId = [];
    const invalidCustomers = [];
    let allCustomerDeals = whichProps.allCustomerDeals
      ? whichProps.allCustomerDeals
      : null;
    let appBarName = allCustomers ? allCustomers.name : null;
    let products = whichProps.products ? whichProps.products : null;
    let customersList = [];
    let tempCustomers = [];
    let tempAllCustomers = [];
    this.setState({ appBarName });
    const tempProducts = [];
    if (products.length > 0) {
      products.map(products => tempProducts.push(products.productName));
    }
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }
    this.setState({ tempProducts });
    allInvoices.length > 0
      ? allInvoices.map(dealsId =>
          dealsId.dealsId.map(data => invoicedDealsId.push(data))
        )
      : console.log("No Invoices Generated Yet");
    tempAllCustomers = allCustomerDeals.filter(
      aCustomerDeals =>
        aCustomerDeals.customerId === customerId &&
        aCustomerDeals.isInvoiceCreated === false
    );
    deals
      .filter(
        deals => deals.buyerId === customerId || deals.sellerId === customerId
      )
      .map(deals => {
        if (invoicedDealsId.length > 0) {
          if (
            invoicedDealsId.find(
              invoiceDeals => invoiceDeals.dealId !== deals.id
            )
          ) {
            let a = deals;
            if (customerId === deals.buyerId) {
              a.customerName = deals.sellerName;
              a.customerId = deals.sellerId;
            }
            if (customerId === deals.sellerId) {
              a.customerName = deals.buyerName;
              a.customerId = deals.buyerId;
            }
            tempCustomers.push(a);
          }
        } else {
          let a = deals;
          if (customerId === deals.buyerId) {
            a.customerName = deals.sellerName;
            a.customerId = deals.sellerId;
          }
          if (customerId === deals.sellerId) {
            a.customerName = deals.buyerName;
            a.customerId = deals.buyerId;
          }
          tempCustomers.push(a);
        }
        return tempCustomers;
      });
    customersList = [...new Set(tempCustomers)];
    this.setState({ customersList });
    let invoiceDeals = [];
    if (tempAllCustomers.length > 0) {
      tempAllCustomers.map(tACustomerDeals => {
        return invoiceDeals.push(tACustomerDeals.dealId);
      });
    } else {
      console.log("false");
    }
    if (invoiceDeals.length > 0) {
      customersList = customersList.filter(val =>
        invoiceDeals.includes(val.id)
      );

      this.setState({ customersList });
    } else {
      allInvoices.length > 0
        ? allInvoices
            .filter(allInvoice => allInvoice.customerId === customerId)
            .map(data =>
              data.otherPartyId.map(opId => invalidCustomers.push(opId))
            )
        : console.log("No Invoices Generated Yet");
      customersList = customersList.filter(
        val => !invalidCustomers.includes(val.customerId)
      );
      this.setState({ customersList });
    }
  };

  updateInvoice = (invoiceId, dealsId, customerId) => {
    this.props.db
      .collection("invoices")
      .doc(invoiceId)
      .update({
        isPaid: true
      });
    dealsId.map(dealsId => {
      return this.props.db
        .collection("customerDeals")
        .doc(customerId + "_" + dealsId)
        .update({ isInvoicePaid: true });
    });
  };
  handleRemoveDeal = (dealId, invoiceId, otherParty, customerId) => {
    if (this.props.unPaidInvoices.length > 0) {
      let removeDeal = this.props.allDeals.find(deals => deals.id === dealId);
      let invoice = this.props.unPaidInvoices.find(
        invoices => invoices.id === invoiceId
      );
      let quantity =
        parseInt(invoice.dealsTotalQuantity) - parseInt(removeDeal.quantity);
      let invoiceAmount =
        parseInt(invoice.invoiceAmount) -
        (customerId === removeDeal.sellerId
          ? parseInt(removeDeal.sellerBrokerage) * parseInt(removeDeal.quantity)
          : parseInt(removeDeal.buyerBrokerage) *
            parseInt(removeDeal.quantity));
      let InvoicesDealsId = invoice.dealsId.filter(
        invoiceDeals => invoiceDeals !== dealId
      );
      let otherPartyId = invoice.otherPartyId.filter(
        otherPartyId => otherPartyId !== otherParty
      );

      let invoices = this.props.db.collection("invoices").doc(invoiceId);
      let customerDeals = this.props.db
        .collection("customerDeals")
        .doc(customerId + "_" + dealId);
      let transaction = this.props.db
        .runTransaction(t => {
          return t.get(invoices).then(doc => {
            return t.get(customerDeals).then(doc => {
              if (InvoicesDealsId.length > 0) {
                t.update(invoices, {
                  dealsId: InvoicesDealsId,
                  dealsTotalQuantity: quantity,
                  invoiceAmount: invoiceAmount,
                  otherPartyId: otherPartyId
                });
              } else {
                t.delete(invoices);
              }
              t.update(customerDeals, { isInvoiceCreated: false });
              return Promise.resolve(" Complete..... ");
            });
          });
        })
        .then(result => {
          console.log("Transaction success ----" + result);
        })
        .catch(err => {
          console.log("Transaction failure:", err);
        });
    } else {
      console.log("empty");
    }
  };
  render() {
    const {
      customersList,
      isLoading,
      appBarName,
      tempProducts,
      organisationId
    } = this.state;
    const {
      user,
      allDeals,
      paidInvoices,
      unPaidInvoices,
      allCustomers,
      currentUser,
      invoicePrintData
    } = this.props;
    return (
      <div>
        <Route
          exact
          path="/invoice/:customerId/InvoiceDetail"
          render={props => (
            <InvoiceDetails
              {...props}
              isLoading={isLoading}
              customersList={customersList}
              appBarName={appBarName}
              paidInvoices={paidInvoices}
              unPaidInvoices={unPaidInvoices}
              allDeals={allDeals}
              allCustomers={allCustomers}
              updateInvoice={this.updateInvoice}
              user={user}
              currentUser={currentUser}
              handleRemoveDeal={this.handleRemoveDeal}
              products={tempProducts}
              invoicePrintData={invoicePrintData}
              organisationId={organisationId}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(InvoiceDetailsContainer)));
